import { PermissionAccessService } from '../../shared/services/permission-access.service';
import { SETTING_MENU_ITEMS } from '../constant/setting-menu';
import { ISettingMenuItem } from '../interface/setting.interface';

/*=====================================
  The first settings page this role is allowed to open - where /settings lands.

  Falls back to the first page when they are allowed none, which the guard then
  refuses. Unreachable in practice: Settings is not drawn in the sidebar for a
  role holding none of these.
  @param permissionAccess - the permission check
  @return the route to land on
======================================*/
export function firstAllowedSettingsPage(
    permissionAccess: PermissionAccessService,
    isSellingEnabled = true,
): string {
    const allowed = SETTING_MENU_ITEMS.find(
        (page) =>
            isSettingsPageOpen(page, isSellingEnabled) &&
            permissionAccess.hasPermission(page.permission),
    );

    return (allowed ?? SETTING_MENU_ITEMS[0]).route;
}

/*=====================================
  Whether a settings page is open at all, before anybody's role is looked at.

  A page that only configures selling closes with the shop, and its address
  closes with it - so landing on one would only bounce the person to Home.
  @param page - the settings menu entry
  @param isSellingEnabled - whether the shop's shopping store is on
  @return whether the page can be opened right now
======================================*/
export function isSettingsPageOpen(page: ISettingMenuItem, isSellingEnabled: boolean): boolean {
    return !page.requiresShoppingStore || isSellingEnabled;
}
